import { useState } from "react"
import useStore from "../../../../store"
import ReusableDrawer from "../../../common/ReusableDrawer"
import { FaCamera, FaRegImage } from "react-icons/fa"

export default function UnitPhotoPreview({ isOpen, onClose, unitId }) {
  const unitFiles = useStore((state) => state.unitFiles)
  const clearUnitFiles = useStore((state) => state.clearUnitFiles)

  const photos = unitFiles.filter((file) => String(file.attributes['unit-id']) === String(unitId))

  const handleClose = () => {
    onClose()
    clearUnitFiles()
  }

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={handleClose}
      placement="bottom"
      title="Unit Photos"
      size="lg"
    >
      {photos.length > 0 ? (
        <div className="grid grid-cols-3 gap-3 p-2">
          {photos.map((file) => (
            <PhotoThumbnail key={file.id} file={file} />
          ))}
        </div>
      ) : (
        <p className="text-center text-grey-300 py-8">No photos available for this unit.</p>
      )}
    </ReusableDrawer>
  )
}

function PhotoThumbnail({ file }) {
  const [status, setStatus] = useState('idle') // idle | loading | loaded | failed

  return (
    <div className="flex flex-col items-center gap-1">
      <div className="w-full aspect-square">
        {status === 'idle' && (
          <button
            onClick={() => setStatus('loading')}
            className="w-full h-full rounded bg-grey-700 flex flex-col items-center justify-center gap-1.5 active:bg-grey-600 transition-colors"
          >
            <FaCamera className="text-grey-400 text-2xl" />
            <span className="text-xs text-grey-400">Tap to load</span>
          </button>
        )}
        {status === 'loading' && (
          <div className="w-full h-full rounded bg-grey-700 animate-pulse" />
        )}
        {status === 'failed' && (
          <div className="w-full h-full rounded bg-grey-700 flex items-center justify-center">
            <FaRegImage className="text-grey-300 text-3xl" />
          </div>
        )}
        {(status === 'loading' || status === 'loaded') && (
          <img
            src={file.attributes.url}
            alt={file.attributes.name}
            className={`w-full h-full object-cover rounded ${status === 'loading' ? 'hidden' : ''}`}
            onLoad={() => setStatus('loaded')}
            onError={() => setStatus('failed')}
          />
        )}
      </div>
      <span className="text-xs text-grey-300 truncate w-full text-center">
        {file.attributes.name}
      </span>
    </div>
  )
}
